// Address Search
(function () {
    // Emergency Address - Additional Searches
    const ecSelectCuntry = document.querySelector("[data-emergency-address-style]");
    if (!ecSelectCuntry) return;
    if (!ecSelectCuntry.classList.contains("hide")) {
        ecDetectAddressStyle();
    }
    function ecDetectAddressStyle() {
        const ecSearchAddressButtonQas = document.getElementById("ecSearchAddressButtonQas");
        const ecSearchAddressButtonBfo = document.getElementById("ecSearchAddressButtonBfo");
        const ecDisclaimerWrapper = document.querySelector(".contact-emergency-disclaimer-wrapper");
        const ecSelectedValue = ecSelectCuntry.value;

        if (ecSelectedValue === "XX") {
            if (ecSearchAddressButtonQas && ecSearchAddressButtonBfo) {
                ecSearchAddressButtonQas.style.display = "none";
                ecSearchAddressButtonBfo.style.display = "block";
                ecDisclaimerWrapper.style.display = "block";

                // Get references to the form elements
                const ecAddress1Input = document.querySelector('[data-ec="address1-input"]');
                const ecAddress2Input = document.querySelector('[data-ec="address2-input"]');
                const ecAddress3Input = document.querySelector('[data-ec="address3-input"]');
                const ecPostcodeInput = document.querySelector('[data-ec="postcode-input"]');
                const ecCountryInput = document.querySelector('[data-ec="county-input"]');
                const bfpoECFullAddressInput = document.getElementById("ec-bfpo-postcode-search");
                const ecErrorSpanBfo = document.querySelector(".ec-bfpo-address-error");

                if (ecPostcodeInput.value === "" || ecPostcodeInput.value === "empty") {
                    ecPostcodeInput.value = "BFPO";
                }
                if (ecCountryInput.value === "") {
                    ecCountryInput.value = "BFPO";
                }

                // Function to update the fullAddress input
                function bfpoECUpdateFullAddress() {
                    const address1 = ecAddress1Input.value || "";
                    const address2 = ecAddress2Input.value || "";
                    const address3 = ecAddress3Input.value || "";
                    const bfpoNnumber = ecPostcodeInput.value || "";

                    bfpoECFullAddressInput.value = `${address1}, ${address2}, ${address3}, ${bfpoNnumber}`;
                }

                ecSearchAddressButtonBfo.addEventListener("click", function () {
                    ecErrorSpanBfo.textContent = "";
                    bfpoECUpdateFullAddress();
                });
                // // Add event listeners to the form elements
                ecAddress1Input.addEventListener("input", bfpoECUpdateFullAddress);
                ecAddress2Input.addEventListener("input", bfpoECUpdateFullAddress);
                ecAddress3Input.addEventListener("input", bfpoECUpdateFullAddress);
                ecPostcodeInput.addEventListener("input", bfpoECUpdateFullAddress);
            }
        } else if (ecSelectedValue === "GB") {
            if (ecSearchAddressButtonQas && ecSearchAddressButtonBfo) {
                ecSearchAddressButtonBfo.style.display = "none";
                ecSearchAddressButtonQas.style.display = "block";
                ecDisclaimerWrapper.style.display = "block";

                // Get references to the form elements
                const ecAddress1Input = document.querySelector('[data-ec="address1-input"]');
                const ecAddress2Input = document.querySelector('[data-ec="address2-input"]');
                const ecAddress3Input = document.querySelector('[data-ec="address3-input"]');
                const ecCityInput = document.querySelector('[data-ec="city-input"]');
                const ecCountyInput = document.querySelector('[data-ec="county-input"]');
                const ecPostcodeInput = document.querySelector('[data-ec="postcode-input"]');
                const quasECFullAddressInput = document.getElementById("ec-postcode-search-qas");

                // Function to update the fullAddress input
                function updateECFullAddress() {
                    const address1 = ecAddress1Input.value || "*";
                    const address2 = ecAddress2Input.value || "*";
                    const address3 = ecAddress3Input.value || "*";
                    const city = ecCityInput.value || "*";
                    const county = ecCountyInput.value || "*";
                    const postcode = ecPostcodeInput.value || "*";
                    quasECFullAddressInput.value = `${address1}, ${address2}, ${address3}, ${city}, ${county}, ${postcode}`;
                }

                ecSearchAddressButtonQas.addEventListener("click", function () {
                    updateECFullAddress();
                });
                // Add event listeners to the form elements
                ecAddress1Input.addEventListener("input", updateECFullAddress);
                ecAddress2Input.addEventListener("input", updateECFullAddress);
                ecAddress3Input.addEventListener("input", updateECFullAddress);
                ecCityInput.addEventListener("input", updateECFullAddress);
                ecCountyInput.addEventListener("change", updateECFullAddress);
                ecPostcodeInput.addEventListener("input", updateECFullAddress);
            }
        } else {
            ecDisclaimerWrapper.style.display = "none";
        }
    }
    window.onload = ecDetectAddressStyle;
    ecSelectCuntry.onchange = ecDetectAddressStyle;

    var ecQasForm = document.querySelector("#ec-postcode-search-form-QAS");
    if (ecQasForm) {
        var submitButton = ecQasForm.querySelector('button[type="submit"]');
        var errorSpan = ecQasForm.querySelector(".ec-qas-message-error");
        submitButton.addEventListener("click", function (event) {
            var list = document.querySelector(".ec-qas-address-list");
            var errorMessage = document.querySelector(".ec-qas-message-error");
            while (list.firstChild) {
                errorMessage.textContent = "";
                list.removeChild(list.firstChild);
            }
            event.preventDefault();
            var postcodeSearchInput = ecQasForm.querySelector('input[name="postcodesearch"]');
            var postcodesearch = postcodeSearchInput ? postcodeSearchInput.value : "";
            // Get the URL from the form's action attribute
            var formAction = ecQasForm.action;
            formAction += "?postcodesearch=" + encodeURIComponent(postcodesearch);
            // Send the form data using JavaScript
            var xhr = new XMLHttpRequest();
            xhr.open("POST", formAction);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            // Construct the form data
            var formData = new FormData();
            formData.append("postcodesearch", postcodesearch);
            // Handle the response
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var addresses = JSON.parse(xhr.responseText);

                    const mainAddressElement = document.querySelector(".contact-main-address-element");
                    const addressSearchModal = document.querySelector(".address-search__modal");
                    if (mainAddressElement || addressSearchModal) {
                        const addressList = document.querySelector(".ec-qas-address-list");
                        // const selectedAddressWrapper = document.querySelector(".ec-qas-selected-address-wrapper");

                        const addressInputs = {
                            address1: document.querySelector('[data-ec="address1-input"]'),
                            address2: document.querySelector('[data-ec="address2-input"]'),
                            address3: document.querySelector('[data-ec="address3-input"]'),
                            city: document.querySelector('[data-ec="city-input"]'),
                            county: document.querySelector('[data-ec="county-input"]'),
                            postcode: document.querySelector('[data-ec="postcode-input"]'),
                        };
                        function handleAddressSelection(event) {
                            const selectedIndex = Array.from(addressList.children).indexOf(event.target.parentNode);
                            const selected = addresses.QAPicklist.PicklistEntry[selectedIndex];
                            // Fill input fields with address data
                            addressInputs.address1.value = selected.QAAddress.AddressLine[0].Line;
                            addressInputs.address2.value = selected.QAAddress.AddressLine[1].Line;
                            addressInputs.address3.value = selected.QAAddress.AddressLine[2].Line;
                            addressInputs.city.value = selected.QAAddress.AddressLine[3].Line;
                            const countyText = selected.QAAddress.AddressLine[4].Line;
                            const countyOptions = addressInputs.county.options;
                            // Check if the county text matches any option in the select dropdown
                            const matchedOption = Array.from(countyOptions).find((option) => option.text === countyText);
                            if (matchedOption) {
                                // Set the matched option as selected in the select dropdown
                                matchedOption.selected = true;
                            } else {
                                // Select the first option in the select dropdown
                                addressInputs.county.selectedIndex = 0;
                            }
                            addressInputs.postcode.value = selected.QAAddress.AddressLine[5].Line;
                        }
                        addressList.addEventListener("click", function (event) {
                            if (event.target.classList.contains("select-address")) {
                                handleAddressSelection(event);
                            }
                        });
                        if (!addresses || !addresses.QAPicklist || !addresses.QAPicklist.PicklistEntry || addresses.QAPicklist.PicklistEntry.length === 0) {
                            const errorMessage = document.querySelector(".ec-qas-message-error");
                            errorMessage.textContent = "Not found the address you're after? Start again or enter the address manually";
                            // selectedAddressWrapper.style.display = "none";
                        } else {
                            var information = addresses.QAPicklist.PicklistEntry[0]["@Information"];
                            var warnInformation = addresses.QAPicklist.PicklistEntry[0]["@WarnInformation"];
                            // Check if both values are true
                            if (information === "true" && warnInformation === "true") {
                                var errorMessage = document.querySelector(".ec-qas-message-error");
                                errorMessage.textContent = "Not found the address you're after? Start again or enter the address manually";
                            } else {
                                addresses.QAPicklist.PicklistEntry.forEach((address) => {
                                    const listItem = document.createElement("li");
                                    listItem.className = "address-item";
                                    const addressDetails = document.createElement("div");
                                    addressDetails.className = "address-details";
                                    addressDetails.textContent = address.PartialAddress;
                                    const selectButton = document.createElement("a");
                                    selectButton.className = "select-address btn";
                                    selectButton.textContent = "Select Address";
                                    selectButton.role = "button";
                                    listItem.appendChild(addressDetails);
                                    listItem.appendChild(selectButton);
                                    addressList.appendChild(listItem);
                                });
                                const buttons = document.querySelectorAll(".select-address");
                                // Add event listener to each button
                                buttons.forEach((button) => {
                                    button.addEventListener("click", () => {
                                        const dialog = button.closest("dialog");
                                        if (dialog) {
                                            dialog.close();
                                        }
                                    });
                                });
                            }
                        }
                    }
                }
            };
            // Send the form data
            xhr.send(formData);
        });
        var postcodeSearchInput = ecQasForm.querySelector('input[name="postcodesearch"]');
        postcodeSearchInput.addEventListener("input", function () {
            errorSpan.textContent = "";
        });
    }

    // Search Address Form BFO
    var ecformBFO = document.querySelector("#ec-postcode-search-form-BFO");
    if (ecformBFO) {
        var submitButton = ecformBFO.querySelector('button[type="submit"]');
        var ecErrorSpanBfo = document.querySelector(".ec-bfpo-address-error");
        submitButton.addEventListener("click", function (event) {
            const list = document.querySelector(".ec-bfpo-address-list");
            while (list.firstChild) {
                ecErrorSpanBfo.textContent = "";
                list.removeChild(list.firstChild);
            }
            event.preventDefault();

            const address1Input = document.querySelector('[data-ec="address1-input"]');
            const address1 = address1Input ? address1Input.value : "";
            const address2Input = document.querySelector('[data-ec="address2-input"]');
            const address2 = address2Input ? address2Input.value : "";
            const countryInput = document.querySelector('[data-ec="country-input"]');
            const country = countryInput ? countryInput.value : "";
            const postcodeInput = document.querySelector('[data-ec="postcode-input"]');
            const postcode = postcodeInput ? postcodeInput.value.toString().replace(/\D/g, "") : "";

            var postcodeSearchInput = ecformBFO.querySelector('input[name="postcodesearch"]');
            var postcodesearch = postcodeSearchInput ? postcodeSearchInput.value : "";

            // Get the URL from the form's action attribute
            var formAction = ecformBFO.action;

            formAction += "?country=" + encodeURIComponent(country) + "&bfpo_number=" + encodeURIComponent(postcode) + "&address_line_2=" + encodeURIComponent(address2) + "&address_line_1=" + encodeURIComponent(address1);
            // Send the form data using JavaScript
            var xhr = new XMLHttpRequest();
            xhr.open("POST", formAction);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            // Construct the form data
            var formData = new FormData();
            formData.append("postcodesearch", postcodesearch);
            // Handle the response
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var items = JSON.parse(xhr.responseText);

                    const mainAddressElement = document.querySelector(".contact-main-address-element");
                    const addressSearchModal = document.querySelector(".address-search__modal");

                    if (mainAddressElement || addressSearchModal) {
                        const addressList = document.querySelector(".ec-bfpo-address-list");
                        // const selectedAddressWrapper = document.querySelector(".ec-bfpo-selected-address-wrapper");

                        const addressInputsBFO = {
                            address3: document.querySelector('[data-ec="address3-input"]'),
                            bfpo_number: document.querySelector('[data-ec="postcode-input"]'),
                            bfpo_country: document.querySelector('[data-ec="county-input"]'),
                        };

                        function handleAddressSelection(event) {
                            const selectedIndex = Array.from(addressList.children).indexOf(event.target.parentNode);
                            const selected = items.items[selectedIndex];
                            addressInputsBFO.address3.value = selected.site_location + ", " + selected.post_code;
                            addressInputsBFO.bfpo_number.value = "BFPO " + selected.bfpo_number;
                            addressInputsBFO.bfpo_country.value = selected.country;
                        }

                        addressList.addEventListener("click", function (event) {
                            if (event.target.classList.contains("select-address")) {
                                handleAddressSelection(event);
                            }
                        });

                        if (!items || !items.items || items.items.length === 0) {
                            const errorMessage = document.querySelector(".ec-bfpo-address-error");
                            errorMessage.textContent = "Not found the address you're after? Start again or enter the address manually";
                            // selectedAddressWrapper.style.display = "none";
                        } else {
                            items.items.forEach((item) => {
                                const listItem = document.createElement("li");
                                listItem.className = "address-item";

                                const addressDetails = document.createElement("div");
                                addressDetails.className = "address-details";

                                if (item.country === null || item.country === "null" || item.country === "") {
                                    addressDetails.textContent = "BFPO" + item.bfpo_number + ", " + item.site_location + ", " + item.post_code;
                                } else {
                                    addressDetails.textContent = "BFPO" + item.bfpo_number + ", " + item.site_location + ", " + item.post_code + ", " + item.country;
                                }

                                const selectButton = document.createElement("a");
                                selectButton.className = "select-address btn";
                                selectButton.textContent = "Select Address";
                                selectButton.role = "button";

                                listItem.appendChild(addressDetails);
                                listItem.appendChild(selectButton);
                                addressList.appendChild(listItem);
                            });
                            const buttons = document.querySelectorAll(".select-address");
                            // Add event listener to each button
                            buttons.forEach((button) => {
                                button.addEventListener("click", () => {
                                    // Find the closest dialog element to the clicked button
                                    const dialog = button.closest("dialog");

                                    if (dialog) {
                                        // Close the dialog if it exists
                                        dialog.close();
                                    }
                                });
                            });
                        }
                    }
                }
                // else {
                //     const errorMessage = document.querySelector(".ec-bfpo-address-error");
                //     const selectedAddressWrapper = document.querySelector(".selected-address-wrapper-bfo");
                //     errorMessage.textContent = "No Addresses Found - API BFO";
                //     selectedAddressWrapper.style.display = "none";
                // }
            };
            // Send the form data
            xhr.send(formData);
        });
        var postcodeSearchInput = ecformBFO.querySelector('input[name="postcodesearch"]');
        postcodeSearchInput.addEventListener("input", function () {
            ecErrorSpanBfo.textContent = "";
        });
    }
})();
